import React, { Component } from 'react';
import { Box, Text } from 'grommet';
import { Button, Input, message } from 'antd';
import { OPS_DATA_URL } from '../config';
import { authenticateToken, getAuthEmailFromToken } from '../utils/auth';

const PHASES = ['PREPARATION', 'MAINTENANCE WINDOW', 'POST UPGRADE ACTIVITY'];

export default class MaintenanceChecklistTemplates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      phases: {
        'PREPARATION': [],
        'MAINTENANCE WINDOW': [],
        'POST UPGRADE ACTIVITY': []
      }
    };
  }

  componentDidMount() {
    this.loadTemplate();
  }

  loadTemplate = async () => {
    this.setState({ loading: true });
    try {
      const res = await fetch(`${OPS_DATA_URL}/maintenance-checklists/templates`);
      if (!res.ok) {
        message.error('Failed to load checklist template.');
        this.setState({ loading: false });
        return;
      }
      const data = await res.json();
      this.setState({
        loading: false,
        phases: data.phases || {
          'PREPARATION': [],
          'MAINTENANCE WINDOW': [],
          'POST UPGRADE ACTIVITY': []
        }
      });
    } catch (e) {
      this.setState({ loading: false });
      message.error('Network error while loading template.');
    }
  }

  addTask = (phase) => {
    this.setState((prev) => ({
      phases: {
        ...prev.phases,
        [phase]: [
          ...(prev.phases[phase] || []),
          { id: `${phase.toLowerCase().replace(/\s+/g, '-')}-${Date.now()}`, title: '', order: (prev.phases[phase] || []).length + 1 }
        ]
      }
    }));
  }

  updateTaskTitle = (phase, index, title) => {
    this.setState((prev) => {
      const list = [...(prev.phases[phase] || [])];
      list[index] = {
        ...list[index],
        title
      };
      return {
        phases: {
          ...prev.phases,
          [phase]: list
        }
      };
    });
  }

  removeTask = (phase, index) => {
    this.setState((prev) => {
      const list = (prev.phases[phase] || []).filter((_, i) => i !== index).map((item, i) => ({
        ...item,
        order: i + 1
      }));
      return {
        phases: {
          ...prev.phases,
          [phase]: list
        }
      };
    });
  }

  saveTemplate = async () => {
    const token = authenticateToken();
    const operator = getAuthEmailFromToken() || '';
    if (!token) {
      message.error('Please sign in again.');
      return;
    }

    const phases = {};
    for (const phase of PHASES) {
      phases[phase] = (this.state.phases[phase] || [])
        .map((item, index) => ({
          ...item,
          title: (item.title || '').trim(),
          order: index + 1
        }))
        .filter((item) => item.title);
    }

    try {
      const res = await fetch(`${OPS_DATA_URL}/maintenance-checklists/templates`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ phases, operator })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        message.error(err.error || 'Failed to save template.');
        return;
      }
      message.success('Checklist template saved.');
      this.loadTemplate();
    } catch (e) {
      message.error('Network error while saving template.');
    }
  }

  renderPhase = (phase) => {
    const list = this.state.phases[phase] || [];
    return (
      <Box key={phase} margin={{ bottom: 'medium' }}>
        <Box direction='row' justify='between' align='center' margin={{ bottom: 'small' }}>
          <Text weight='bold'>{phase}</Text>
          <Button onClick={() => this.addTask(phase)}>Add Task</Button>
        </Box>
        {list.length === 0 ? (
          <Text size='small'>No tasks yet.</Text>
        ) : list.map((task, index) => (
          <Box key={task.id || `${phase}-${index}`} direction='row' gap='small' margin={{ bottom: 'xsmall' }}>
            <Input
              value={task.title}
              onChange={(event) => this.updateTaskTitle(phase, index, event.target.value)}
              placeholder='Task title'
            />
            <Button onClick={() => this.removeTask(phase, index)}>Remove</Button>
          </Box>
        ))}
      </Box>
    );
  }

  render() {
    return (
      <Box width='100%' align='start'>
        <Box direction='row' justify='between' align='center' width='100%' margin={{ bottom: 'small' }}>
          <Text size='large' weight='bold'>Maintenance Checklist Templates</Text>
          <Button type='primary' loading={this.state.loading} onClick={this.saveTemplate}>Save Template</Button>
        </Box>
        {PHASES.map(this.renderPhase)}
      </Box>
    );
  }
}
